module.exports = "<section id=\"calendar-content\"></section>\r\n";